var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('v-container',{staticClass:"pa-0"},[_c('div',{staticClass:"d-flex flex-column-reverse flex-md-row justify-space-between"},[_c('ul',[_vm._t("header")],2),_vm._t("footer")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }